import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DeviceState } from '../reducers/device.reducer';
import { DEVICE_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<DeviceState>(DEVICE_FEATURE_KEY);

export const selectLocked = createSelector(selectState, (state: DeviceState) => state.locked);
